/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-empty-function */
import NewButton from 'components/elements/NewButton'
import Stack from 'components/elements/Stack'
import AuthGoogle from 'components/feature/Authentication/AuthGoogle'
import { legalTOSRoute, legalPrivacyRoute } from 'lib/constants/routes'
import { parseTranslationInterpolation } from 'lib/features/translation'
import _useTranslation from 'lib/hooks/_useTranslation'
import { AdditionalSignUpAttributes, LoginSteps } from 'lib/tracking/attribution/signupattributes'
import { Body2 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import styled, { css } from 'styled-components'
import EmailIcon from 'assets/png-preview/dark-mail.svg'
import CheckIcon from 'assets/png-preview/dark-check.svg'
import Row from 'components/elements/Row'
import { useToggleState } from 'lib/hooks/useToggleState'
import DarkAuthEmailStepByStep from 'components/feature/Authentication/DarkAuthEmailStepByStep'
import { KnowSeoInfo } from 'interfaces/KnowSeoInfo'
import { getCountryConfig } from 'lib/constants/countryconfig'
import BackgroundImage from 'assets/png-preview/background.webp'
import { parseLocale } from 'lib/constants/localization'
import { useRouter } from 'next/router'

const BannerCard = styled.div<{
    showEmailBannerFlow: boolean
    isShownForUnblurredPages?: boolean
    isDarkTheme?: boolean
    showGradientKnowPageDesign?: boolean
    showGradientBannerExperiment?: boolean
}>`
    margin: auto auto;
    display: flex;
    grid-template-columns: 1fr;
    place-content: center;

    background: url(${BackgroundImage.src}) -200px 0px / cover no-repeat,
        radial-gradient(60% 65% at 100% 55%, rgb(188, 59, 138, 0.5) 0%, rgba(188, 59, 138, 0) 100%),
        linear-gradient(220deg, rgba(23, 37, 84, 0.99) 0%, #5a6c9d 50.68%, #172554 120.34%);

    mix-blend-mode: soft-light;

    border-radius: ${theme.borderRadius.huge};
    height: auto;
    width: 100%;
    max-width: fit-content;
    overflow: hidden;
    box-shadow: 5px 10px 50px rgba(7, 7, 7, 0.3);
    transition: all 0.5s ease;

    img {
        object-fit: scale-down;
    }
    .image {
        height: 100%;
        background-color: ${({ isDarkTheme }) => (isDarkTheme ? theme.colors.darkThemePrimary : theme.colors.snowWhite)};
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .headline {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        h2 {
            width: fit-content;
        }
    }
    && h2,
    h3 {
        font-family: var(--font-inter);
        font-weight: 600;
        font-size: 20px;
        line-height: 26px;
        max-width: 450px;
        color: ${theme.colors.white};
        margin: 0;
        margin-bottom: 0px;
        text-align: center;
        letter-spacing: 0.3px;
        text-transform: none;
        span {
            display: block;
            font-family: var(--font-inter);
            font-weight: 600;
            font-size: 20px;
            line-height: 24px;
            max-width: 450px;
            color: ${theme.colors.accentBlueContrast};
            margin: 0;
            margin-bottom: 0px;
            text-align: center;
            letter-spacing: 0.3px;
            text-transform: none;
        }
    }

    .title {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
    }
    .benefits {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: 5px;
        padding: 0 0 0 115px;
        justify-content: center;

        p {
            font-family: var(--font-inter);
            font-weight: 350;
            letter-spacing: 0.5px;
            font-size: 17px;
            line-height: 24px;

            color: ${theme.colors.lightGrayBackground};
        }
    }
    .content {
        padding: 24px 32px;
        max-width: 563px;
        width: 563px;
    }
    .options {
        display: grid;
        justify-content: center;
        gap: 4px;
        grid-template-columns: 400px;
        padding: 6px 0 12px 0;
        position: relative;
        .google-container {
            height: 40px;
        }
        .email-button {
            position: relative;
            button div {
                border: none;
            }
            p {
                font-family: var(--font-inter);
                font-weight: 550;
                font-size: 17px;
                line-height: 20px;
                letter-spacing: 0.3px;
                color: ${theme.colors.lightGrayBackground};
            }
            svg {
                fill: none;
                top: 2px;
            }
        }
    }

    span {
        transition: all 1.5s ease;
        animation: showEmailButton 1.5s 1 ease-in-out forwards;
        @keyframes showEmailButton {
            0% {
                opacity: 0;
            }
            50% {
                opacity: 0;
            }

            100% {
                opacity: 1;
            }
        }
    }

    a {
        color: ${({ isDarkTheme }) => (isDarkTheme ? theme.colors.white : theme.colors.body1Black)};
    }

    ${({ showEmailBannerFlow }) =>
        showEmailBannerFlow
            ? css`
                  .email-container,
                  .password-container {
                      grid-template-columns: 400px;
                      gap: 12px;
                      position: relative;
                      padding: 12px 0 14px 0 !important;
                      left: 0px;
                      p {
                          font-family: var(--font-inter);
                          font-weight: 550;
                          font-size: 17px;
                          line-height: 20px;
                          letter-spacing: 0.3px;
                          color: ${theme.colors.lightGrayBackground};
                      }
                  }
                  .email-banner {
                      display: flex;
                      justify-content: center;
                      input {
                          border-radius: ${theme.borderRadius.rounded} !important;
                          border: none !important;
                          position: relative;
                          bottom: 1px;
                          margin: 0 !important;
                      }
                      button {
                          div {
                              height: 45px;
                              width: 100%;
                              border: none;
                          }
                      }
                  }
                  .inputs {
                      * {
                          color: ${theme.colors.white};
                      }
                      gap: 15px;
                      display: grid;
                      grid-template-columns: 1fr 1fr;
                  }
              `
            : ''};
`

const LegalArticleLink = styled.a`
    && {
        font-family: var(--font-inter);
        font-size: 11px !important;
        line-height: 16px;
        letter-spacing: 0.5px;
        font-weight: 400;
        cursor: pointer;
        color: ${theme.colors.accentBlueContrast};
    }
`

const LegalText = styled(Body2)`
    && {
        font-family: var(--font-inter);
        font-size: 11px !important;
        line-height: 16px;
        letter-spacing: 0.5px;
        color: ${theme.colors.grayScaleSecondary};
    }
`

interface Props {
    additionalSignUpAttributes?: AdditionalSignUpAttributes
    onSuccessSignup: (isNewAccount: boolean, type: 'google' | 'apple' | 'email') => void
    onEmailButtonClick: () => void
    knowSeoInfo?: KnowSeoInfo
    index: number
    isDarkTheme?: boolean
    showOnboardingQuestion?: boolean
    showOnboardingQuestionVariant?: boolean
    showGradientKnowPageDesign?: boolean
    showGradientBannerExperiment?: boolean
}

const DarkThemeImageBannerBody = ({
    knowSeoInfo,
    additionalSignUpAttributes,
    onSuccessSignup,
    onEmailButtonClick,
    index,
    isDarkTheme,
    showOnboardingQuestionVariant,
    showOnboardingQuestion,
    showGradientKnowPageDesign,
    showGradientBannerExperiment,
}: Props) => {
    const [showEmailBannerFlowElement, toggleEmailBannerFlowElement] = useToggleState(false)
    const { t } = _useTranslation('knows')
    const { t: tCommon } = _useTranslation('common')

    const { locale } = useRouter()
    const parsedLocale = parseLocale(locale)
    const { unblurContentForSmallerMarkets } = getCountryConfig(parsedLocale.countryCode)
    const fullyUnblurPDFPagesForSmallerMarkets = unblurContentForSmallerMarkets

    const onEmailClick = () => {
        onEmailButtonClick()
    }

    return (
        <BannerCard
            showEmailBannerFlow
            isShownForUnblurredPages={fullyUnblurPDFPagesForSmallerMarkets}
            isDarkTheme={isDarkTheme}
            showGradientKnowPageDesign={showGradientKnowPageDesign}
            showGradientBannerExperiment={showGradientBannerExperiment}
        >
            <div className="content">
                <Stack gutter={16}>
                    <div className="headline">
                        <h2>
                            {
                                t('knows/signUpRevealStudyNote', {
                                    subject: knowSeoInfo?.know.subjects?.length ? knowSeoInfo.know.subjects[0].name : '',
                                }).split('. ')[0]
                            }
                            <span>
                                {
                                    t('knows/signUpRevealStudyNote', {
                                        subject: knowSeoInfo?.know.subjects?.length ? knowSeoInfo.know.subjects[0].name : '',
                                    }).split('. ')[1]
                                }
                            </span>
                        </h2>
                    </div>

                    {!(showOnboardingQuestionVariant && showOnboardingQuestion) ? (
                        <div className="benefits">
                            <Row gap={8}>
                                <CheckIcon />
                                <Body2>{t('knows/pngPreviewConversionBannerAdvantageAccess')}</Body2>
                            </Row>
                            <Row gap={8}>
                                <CheckIcon />
                                <Body2>{t('knows/pngPreviewConversionBannerAdvantageImproveGrades')}</Body2>
                            </Row>
                            <Row gap={8}>
                                <CheckIcon />
                                <Body2>{t('knows/pngPreviewConversionBannerAdvantageJoinCommunity')}</Body2>
                            </Row>
                        </div>
                    ) : null}
                </Stack>

                <Stack gutter={0}>
                    {showEmailBannerFlowElement ? (
                        <div className="email-banner">
                            {additionalSignUpAttributes ? (
                                <DarkAuthEmailStepByStep
                                    type={LoginSteps.SignUpEmail}
                                    additionalSignUpAttributes={additionalSignUpAttributes}
                                    onClick={() => {}}
                                    onSuccess={(isNewAccount) => onSuccessSignup(isNewAccount, 'email')}
                                    isDark
                                    removeMargins
                                    isSmall
                                    buttonText={tCommon('common/createFreeAccount')}
                                />
                            ) : null}
                            <span />
                        </div>
                    ) : (
                        <div className="options">
                            {additionalSignUpAttributes ? (
                                <AuthGoogle
                                    type={LoginSteps.SignUp}
                                    additionalSignUpAttributes={additionalSignUpAttributes}
                                    onClick={() => {}}
                                    onSuccess={(isNewAccount) => onSuccessSignup(isNewAccount, 'google')}
                                    handleNoAccount={() => {}}
                                    disableExtraStyling
                                    usePillDesign
                                />
                            ) : null}
                            <span onClick={onEmailClick} className="email-button">
                                <NewButton
                                    onClick={() => {
                                        toggleEmailBannerFlowElement()
                                    }}
                                    icon={<EmailIcon />}
                                    color={theme.colors.backgroundTransparent}
                                    height={44}
                                    fullWidth
                                    borderRadius={theme.borderRadius.rounded}
                                >
                                    <Body2
                                        fontWeight={500}
                                        fontFamily="var(--font-inter)"
                                        color={theme.colors.lightGrayBackground}
                                    >
                                        Email
                                    </Body2>
                                </NewButton>
                            </span>
                        </div>
                    )}
                    <Stack gutter={10}>
                        {showEmailBannerFlowElement ? (
                            <LegalText
                                textAlign="center"
                                color={isDarkTheme ? theme.colors.white : theme.colors.body1Black}
                                fontFamily="var(--font-inter)"
                                fontWeight={400}
                                fontSize={12}
                                style={{ cursor: 'pointer' }}
                                onClick={toggleEmailBannerFlowElement}
                            >
                                {tCommon('common/signUpWithGoogleButton')}
                            </LegalText>
                        ) : (
                            <LegalText
                                textAlign="center"
                                color={isDarkTheme ? theme.colors.white : theme.colors.subtitleBlack}
                                fontFamily="var(--font-inter)"
                                fontWeight={400}
                                fontSize={12}
                            >
                                {parseTranslationInterpolation(t('knows/signUpRegisterLegalMessage'), [
                                    { index: 1, component: LegalArticleLink, props: { href: legalTOSRoute } },
                                    { index: 3, component: LegalArticleLink, props: { href: legalPrivacyRoute } },
                                ])}
                            </LegalText>
                        )}
                    </Stack>
                </Stack>
            </div>
        </BannerCard>
    )
}

export default DarkThemeImageBannerBody
